import store from './../../../store';
import acctService from './../../../services/account';

export default {
  data() {
    return {
      email: '',
      emailSent: false,
      doingSomething: false,
      errmsg: '',
    };
  },
  mounted() {
    this.doingSomething = false;
    if (store.state.auth.user && store.state.auth.user.email) {
      this.email = store.state.auth.user.email;
    } else {
      console.log('ERROR: Unable to find current users email');
    }
    if (!store.state.auth.user.user_id) {
      console.log('ERROR: Unable to find current users user_id');
    }
  },
  methods: {
    sendemail() {
      this.errmsg = '';
      this.doingSomething = true;
      const vm = this;
      const clearErrMsg = function clearErrMsg() { vm.doingSomething = false; vm.errmsg = ''; };
      const cbSuccess = function cbSuccess(response) {
        vm.doingSomething = false;
        vm.emailSent = true;
        vm.errmsg = '';
      };
      const cbFail = function cbFail(response) {
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error resetting password - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error resetting password - Please try again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      if (!store.state.auth.user || !store.state.auth.user.user_id) {
        vm.errmsg = 'Internal error - Please logout and login again';
      }
      acctService.resetpw(store.state.auth.user.user_id, cbOptions);
    },
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/user/resetpw/index.js